jQuery(document).ready(function ($) {
    $(document.body).on('added_to_cart', function (event, fragments, cart_hash, button) {
        // Get the cart count and update it
        console.log('cane!');
        var cartCount = fragments['div.widget_shopping_cart_content'].split('<span class=\"quantity\">');
        var TotalCount = 0;
        for (let index = 1; index < cartCount.length; index++) {
            var item = cartCount[index];
            var ItemCount = item.split(' &times;')[0];
            TotalCount += parseInt(ItemCount);
        }
        $('#cart-count').text(TotalCount);
    });

    $('body').on('removed_from_cart', function () {
        console.log('removed');
    });
});
